module.exports = __webpack_public_path__ + "media/images/ic_silver_medal-e8814505f21440b53d388f73fbddd5b1.png";